import React from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { useNavigate } from "react-router-dom";

const KitTransaction = () => {
  const navigate = useNavigate();


  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid py-4">
              <div className="card shadow-sm p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="mb-0 text-primary">Kit Distribution - Student Details</h4>
                  <button className="btn btn-outline-danger" onClick={() => navigate(-1)}><i className="bi bi-arrow-left-circle me-1"></i>
                    Back
                  </button>
                </div>

                {/* Student Details Section */}
                <div className="border-0 rounded p-3 mb-4 ">
                  <h5 className="fw-semibold mb-3">Student Info</h5>
                  <div className="row">
                    
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                     
                     
                      <select className="form-select" >
                        <option>Rahul Yadav (3453)</option>
                      </select>
                      <label className="ms-5">Student Name</label>
                    </div>
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      
                      <input className="form-control" value="3453"   />
                      <label className="ms-5">Roll No.</label>
                    </div>
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      <input className="form-control" value="Ram Yadav"   />
                      <label className="ms-5">Father's Name</label>
                    </div>
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      <input className="form-control" value="7742458677"   />
                      <label className="ms-5">Mobile</label>
                    </div>
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      <input className="form-control" value="10"   />
                      <label className="ms-5">Batch Name</label>
                    </div>
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      <input className="form-control" value="X"   />
                      <label className="ms-5">Course Name</label>
                    </div>
                    <div className="border-0 rounded p-3 mb-4 ">
                  <h5 className="fw-semibold mb-3">Kit Details</h5>
                  <div className="row">
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      <select className="form-select">
                      <label className="ms-5">Kit Name</label>
                        <option>Select Kit</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3 form-floating form-floating-outline">
                      <input type="number" className="form-control" defaultValue="1" />
                      <label className="ms-5">Quantity</label>
                    </div>
                    <div className="col-12 mb-3 form-floating form-floating-outline">
                      <textarea
                        className="form-control input-uppercase"
                        rows="2"
                        placeholder="Enter remark here..."
                      ></textarea>
                      <label className="ms-5">Remark</label>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="text-end">
                  <button className="btn btn-primary  px-4 mx-2">Submit</button>
                    {/* <button className="btn btn-danger" onClick={() => navigate(-1)}>
                    Back
                  </button> */}
                </div>

                  </div>
                </div>

                {/* Kit Details Section */}
       
              </div>
            </div>

            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default KitTransaction;
